import {$, ElementDecorator} from '../util/view'
import {kebabCase} from '../util/string'
import {parseURL} from '../util/url'
import {parentQuerySelector} from '../util/dom'

export interface Item {
  title: string,
  body: ElementDecorator,
  onSelect?: EventListener
}

export interface Options {
  onSwitch?: EventListener,
  items: Item[]
}

const switchNav = (container: Element, navLink: Element): void => {
  const current = container.querySelector('.mol-ads-cmp--tab.active')

  if (current) {
    current.classList.remove('active')
  }

  (navLink.parentNode as Element).classList.add('active')
}

const switchBody = (container: Element, navLink: HTMLElement): void => {
  const current = container.querySelector('.mol-ads-cmp--tab-body.active')

  if (current) {
    current.classList.remove('active')
  }

  const id = navLink.dataset.current
  const body = id && document.getElementById(id)

  if (body) {
    body.classList.add('active')
  }
}

const switchTabs = (event: Event) => {
  event.preventDefault()

  const target = event.target as Element

  if (!target) {
    event.stopImmediatePropagation()
    return
  }

  const container = parentQuerySelector(target, '.mol-ads-cmp--tabs-container')

  if (!container) {
    throw new Error('Can\'t find tab container')
  }

  switchNav(container, target)
  switchBody(container as HTMLElement, target as HTMLElement)
}

export type TabsView = ElementDecorator & {switchTabs: () => void}

export default function ({
  onSwitch = () => {},
  items
}: Options): TabsView {
  const settings = (
    $('div', {class: 'mol-ads-cmp--tabs-container'}, [
      $('ul', {class: 'mol-ads-cmp--tabs'}, items.map(({title, onSelect = () => {}}, index) =>
        $('li', {
          class: {
            'active': index === 0,
            'mol-ads-cmp--tab': true
          }
        }, [
          $('a', {
            'class': 'mol-ads-cmp--tab-trigger',
            'data-current': kebabCase(title),
            'data-index': index,
            'href': `#${kebabCase(title)}`
          }, title)
            .click([switchTabs, onSwitch])
            .click(onSelect)
        ])
      )),
      ...items.map((item, index) =>
        $('div', {
          class: {
            'active': index === 0,
            'mol-ads-cmp--tab-body': true
          },
          id: kebabCase(item.title)
        }, item.body)
      )
    ])
  )

  return Object.assign(settings, {
    switchTabs: (): void => {
      const event = new CustomEvent('click', {cancelable: false})
      onSwitch(event)

      const tab = settings.raw.querySelector('.mol-ads-cmp--tab:not(.active) .mol-ads-cmp--tab-trigger')
      if (tab) {
        switchNav(settings.raw, tab as HTMLElement)
        switchBody(settings.raw, tab as HTMLElement)
      }
    }
  })
}
